export default "__VITE_ASSET__OXX1pDM9__"